import { render, staticRenderFns } from "./BoardAdmin.vue?vue&type=template&id=11a60360&"
import script from "./BoardAdmin.vue?vue&type=script&lang=js&"
export * from "./BoardAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports